// THIS FILE IS AUTOGENERATED
// DO NOT EDIT THIS FILE!

import * as lunr from "lunr";
export const tokenize = (input) => lunr.tokenizer(input)
  .map(token => token.str);
export default lunr;
export const docsBasePath = "docs";
export const blogBasePath = "blog";
export const indexDocSidebarParentCategories = 0;
